/* Contentful */
const CONTENTFUL_URL = "https://cdn.contentful.com/spaces/vzrchh5059a8/environments/master/entries" +
    "?access_token=rycvlQrg1NFTKqUz7jfatycdJ9nuFrsxh8LlfViD9so";

function fetchContentful(contentType: string): Promise<any> {
    return fetch(`${CONTENTFUL_URL}&content_type=${contentType}`).then(r => r.json());
}

/* State */
const state = {

    /* Template - Foto */
    searchImagen(idPhoto: string, data: any) {
        return data.includes.Asset.find((item: any) => item.sys.id === idPhoto);
    },

    /* Welcome */
    addNotice(params: any) {
        const template: any = document.querySelector(".noticias__template");
        const container = document.querySelector(".body__noticias");
        template.content.querySelector(".noticias__title").textContent = params.titulo;
        template.content.querySelector(".noticias__subtitle").textContent = params.informacion;
        template.content.querySelector(".noticias__photo").src = params.foto;
        container.appendChild(document.importNode(template.content, true));
    },
    dataWelcome() {
        fetchContentful("home").then(data => {
            data.items.forEach((item: any) => {
                this.addNotice({
                    titulo: item.fields.titulo,
                    informacion: item.fields.informacion,
                    foto: this.searchImagen(item.fields.foto.sys.id, data).fields.file.url,
                });
            });
        });
    },

    /* Trabaja */
    addJob(params: any) {
        const template: any = document.querySelector(".job__template");
        const container = document.querySelector(".job__container");
        template.content.querySelector(".job__titulo").textContent = params.puesto;
        template.content.querySelector(".job__descripcion").textContent = params.descripcion;
        template.content.querySelector(".job__disponibilidad").textContent = params.disponibilidad;
        container.appendChild(document.importNode(template.content, true));
    },
    dataJob() {
        fetchContentful("busquedas").then(data => {
            data.items.forEach((item: any) => {
                this.addJob({
                    puesto: item.fields.puesto,
                    descripcion: item.fields.descripcion,
                    disponibilidad: item.fields.disponibilidad,
                });
            });
        });
    },

    /* Sedes */
    addSedes(params: any) {
        const template: any = document.querySelector(".sedes__template");
        const container = document.querySelector(".sedes__container");
        template.content.querySelector(".sedes__titulo").textContent = params.periferico;
        template.content.querySelector(".sedes__direccion").textContent = params.direccion;
        template.content.querySelector(".sedes__phone").textContent = params.telefono;
        template.content.querySelector(".sedes__mail").textContent = params.contacto;
        template.content.querySelector(".sedes__photo").src = params.foto;
        container.appendChild(document.importNode(template.content, true));
    },
    dataSedes() {
        fetchContentful("sucursales").then(data => {
            data.items.forEach((item: any) => {
                this.addSedes({
                    periferico: item.fields.periferico,
                    direccion: item.fields.direccion,
                    telefono: item.fields.telefono,
                    contacto: item.fields.contacto,
                    foto: this.searchImagen(item.fields.foto.sys.id, data).fields.file.url,
                });
            });
        });
    },

    /* Profesionales */
    addProfesionales(params: any) {
        const template: any = document.querySelector(".profesional__template");
        const container = document.querySelector(".body__profesionales-container");
        template.content.querySelector(".profesional__especialidad").textContent = params.Especialidad;
        template.content.querySelector(".profesional__info").textContent = params.Profesional;
        container.appendChild(document.importNode(template.content, true));
    },
    dataProfesionales(data: any[]) {
        data.forEach(i => this.addProfesionales(i));
    },

    /* Mutuales */
    addMutuales(mutual: string) {
        const template: any = document.querySelector(".mutuales__template");
        const container = document.querySelector(".body__mutuales-container");
        template.content.querySelector(".mutuales__info").textContent = mutual;
        container.appendChild(document.importNode(template.content, true));
    },
    dataMutuales(data: string[]) {
        data.forEach(mutual => this.addMutuales(mutual));
    },

};

/* Export */
export { state };
